import { render, staticRenderFns } from "./_common_center.vue?vue&type=template&id=0eee8b85"
import script from "./_common_center.vue?vue&type=script&lang=js"
export * from "./_common_center.vue?vue&type=script&lang=js"
import style0 from "./_common_center.vue?vue&type=style&index=0&id=0eee8b85&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0eee8b85')) {
      api.createRecord('0eee8b85', component.options)
    } else {
      api.reload('0eee8b85', component.options)
    }
    module.hot.accept("./_common_center.vue?vue&type=template&id=0eee8b85", function () {
      api.rerender('0eee8b85', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layout/_common_center.vue"
export default component.exports